module.exports = new __parcel__URL__("step_two_vector_dark_optimal.34c23cb4.png").toString();